export default __webpack_public_path__ + "static/media/gray_tick.b191a074.svg";